const questions = [
  {
    id: 1,
    title: "Zoo w Gdańsku – największy ogród zoologiczny",
    description:
      "W Gdańsku działa największe w Polsce zoo – zajmuje ponad 123 hektary powierzchni i mieści się w Oliwie.",
  },
  {
    id: 2,
    title: "Historia Gdańska – Miasto filozofów i wynalazców",
    description:
      "W Gdańsku urodził się Artur Schopenhauer. Jeden z najbardziej znanych niemieckich myślicieli przyszedł na świat w gdańskim śródmieściu, w domu przy ulicy Świętego Ducha 47, mieszczącym się bardzo blisko Bazyliki Mariackiej.",
  },
  {
    id: 3,
    title: "Bazylika Mariacka w Gdańsku – Największa średniowieczna świątynia",
    description:
      "Gdańsk może poszczycić się jedną z największych w Europie świątyń. Bazylika Mariacka, jeden z popularnych zabytków, jest najwyższą średniowieczną świątynią wybudowaną z cegły. Wysokość wieży kościoła razem z kalenicą wynosi aż 82 metry.",
  },
  {
    id: 4,
    title: "Atrakcje w Gdańsku jak we Włoszech – Krzywa kamienica",
    description:
      "Krzywa kamienica stoi przy skrzyżowaniu dwóch ulic – Lawendowej oraz Świętojańskiej – i jest odchylona od pionu aż o 50 cm!",
  },
  {
    id: 5,
    title: "W 1308 roku Gdańsk był oblegany przez Brandenburczyków",
    description:
      "W efekcie wezwano na pomoc Krzyżaków, którzy okazali się nie wyswobodzicielami a wrogami. Wdarli się do grodu, spalili go i dokonali pogromu ludności Gdańska, który przeszedł do historii jako 'rzeź Gdańska'. W jej wyniku zginęło kilkuset Gdańszczan.",
  },
  {
    id: 6,
    title: "W XVI wieku Gdańsk był potęgą gospodarczą Europy Środkowej",
    description:
      "Nurtem Wisły spławiano barki ze zbożem i drewnem. Z portów angielskich, niderlandzkich i niemieckich przypływały wyroby sukiennicze, korzenne przyprawy i przedmioty zbytku. Rosło bogactwo miasta i jego mieszkańców.",
  },
  {
    id: 7,
    title:
      "W XVII wieku Gdańsk był największym ośrodkiem w Rzeczypospolitej - zamieszkiwało go 80 tys. osób",
    description:
      "Bogactwo miasta zachęcało licznych artystów, którzy oferowali swoje usługi cechom kupieckim i znamienitym rodom mieszczańskim. Dzięki temu miasto wzbogaciło sie o arcydzieła architektury i sztuki.",
  },
  {
    id: 8,
    title:
      "Mieszczanie gdańscy nie uznali wyboru Batorego na króla i odmówili złożenia mu hołdu w 1577 roku",
    description:
      "Doprowadziło to do oblężenia miasta przez wojska królewskie, wobec czego patrycjusze skapitulowali uznając władzę Batorego. Kosztowało ich to wysoką kontrybucję.",
  },
];

export default questions;
